export default {
  man: [
    {
      id: `man-tshirt`,
      variant: `danger`,
      title: `Футболка`,
      description: `Ищете практичный и оригинальный подарок для мужчины? Мы все придумали за вас. Выбирайте из нескольких тысяч готовых принтов или печатайте собственный уникальный дизайн. Нужен подарок меломану? Подойдет название любимой группы, обложка знакового альбома или та самая фотография с концерта. Хотите что-то забавное? Выбирайте принты с прикольными фразами и смешными надписями. Мужу — футболку «лучший муж», бойфренду — картинку его знака зодиака или универсальный вариант — с именем.
      Все футболки изготавливаются из качественного плотного хлопка, а уникальные дизайны не выцветают даже после пятидесяти стирок. Наши футболки приятно дарить и еще приятнее носить!`,
      link: `/products/men_tshirts`
    },
    {
      id: `man-cup`,
      variant: `info`,
      title: `Кружка`,
      description: `Кружка с оригинальным принтом — всегда уместный и одновременно универсальный подарок: ей найдется применение и дома, и на работе. Шефу придется по душе кружка-поздравление с профессиональным праздником, а лучшему другу — вдохновляющая мотивационная фраза или «ваша» внутренняя шутка. Самый нейтральный вариант — кружка с памятной фотографией или забавным селфи одариваемого.`,
      link: `/products/cups`
    },
    {
      id: `umbrella`,
      variant: `success`,
      title: `Зонт`,
      description: `Зонт — непростой предмет. Он часто ломается, оставляется дома и забывается в неожиданных местах. А потому это идеальный вариант для подарка: зонт никогда не будет лишним! В зависимости от принта или узора зонтик может быть прекрасным подарком как близкому другу, так и коллеге или партнеру по бизнесу. Выбирайте нейтральные и минималистичные принты для знакомых и коллег — «Звездную ночь» Ван Гога или узор из осенних листьев, озорные и забавные — для близких друзей и родственников: смайлики, персонажей аниме или головокружительные геометрические узоры.`,
      link: `/products/umbrellas`
    },
    {
      id: `underpants`,
      variant: `warning`,
      title: `Трусы`,
      description: `Вариант для близких людей с чувством юмора :) Ироничные, яркие и веселые принты сделают такую тривиальную вещь как трусы оригинальным и особенным подарком. Классический принт с сердечками — абсолютный хит на День Святого Валентина, прикольные надписи и абстрактные узоры подойдут на любой праздник. И самое главное: трусы с Суперменом должны быть у каждого!`,
      link: `/store/clothing/trusy/muzhskie-trusy`
    },
    {
      id: `man-sweatshirt`,
      variant: `danger`,
      title: `Свитшот`,
      description: `Подарите мужчине свитшот с любимой музыкальной группой — и смотрите, как он будет рад! Это одновременно и практичный, и оригинальный подарок, который выделит его из толпы и будет напоминать о вашем внимании и заботе. Свитшоты изготавливаются из 100% хлопка, приятны к телу и не выцветают после многократных стирок. Ваш подарок прослужит долго!`,
      link: `/store/clothing/men_sweatshirts/muzika`
    }
  ],
  woman: [
    {
      id: `woman-tshirt`,
      variant: `danger`,
      title: `Футболка`,
      description: `Ищете практичный и оригинальный подарок женщине? Мы все придумали за вас. Выбирайте из нескольких тысяч готовых принтов или печатайте собственный уникальный дизайн. Девушка любит музыку? Подойдет название любимой группы, обложка знакового альбома или та самая фотография с концерта. Хотите что-то забавное? Выбирайте принты с прикольными фразами и смешными надписями. Жене — футболку «лучшая жена», подруге — картинку с ее знаком зодиака или универсальный вариант — с именем.
      Все футболки изготавливаются из качественного плотного хлопка, а уникальные дизайны не выцветают даже после пятидесяти стирок. Наши футболки приятно дарить и еще приятнее носить!`,
      link: `/products/women_tshirts`
    },
    {
      id: `woman-cup`,
      variant: `info`,
      title: `Кружка`,
      description: `Кружка с оригинальным принтом — всегда уместный и одновременно универсальный подарок: ей найдется применение и дома, и на работе. Шефу придется по душе кружка-поздравление с профессиональным праздником, а лучшему другу — вдохновляющая мотивационная фраза или «ваша» внутренняя шутка. Самый нейтральный вариант — кружка с памятной фотографией или забавным селфи одариваемого.`,
      link: `/products/cups`
    },
    {
      id: `chocolate`,
      variant: `success`,
      title: `Шоколадка`,
      description: `Может быть как персонализированным дополнением к основному подарку, так и самостоятельным небольшим презентом. Шоколадки с сердечками — всегда актуальный подарок на День всех влюбленных или годовщину отношений. На День учителя подарите учительнице набор конфет с поздравлением. Маме, сестре или подруге сделайте индивидуальный дизайн с их фотографией или забавной фразой и шуткой.`,
      link: `/products/shokoladki`
    },
    {
      id: `canvas`,
      variant: `warning`,
      title: `Холст`,
      description: `Хотите оригинальный подарок? Дарите картину. Но не первую попавшуюся из магазина товаров для дома, а с индивидуальным дизайном. Самые популярные варианты — репродукции известных произведений искусства: такой подарок будет уместен, даже если вы не очень хорошо знаете одариваемого. Более современные варианты — плакаты и мотивационные надписи — идеальный подарок подросткам и молодым целеустремленным девушкам. И всегда актуальный вариант — холст с фотографией.`,
      link: `/products/holsty`
    },
    {
      id: `pillow`,
      variant: `danger`,
      title: `Подушка`,
      description: `Мягких и удобных подушек много не бывает, верно? Декоративную подушку с подходящим принтом оценит и мама, и младшая сестра, и лучшая подружка. В нашем магазине вы найдете более 1500 готовых дизайнов! Для мамы выбирайте нейтральные принты, которые подойдут к интерьеру дома. Сестренка придет в восторг от принта с животными или любимыми героями мультиков — миньонами, Свинкой Пеппой. А подушка с любимым музыкантом или актером точно понравится подруге.`,
      link: `/store/home_supplies/pillows`
    }
  ],
  child: [
    {
      id: `kids-sweatshirt`,
      variant: `danger`,
      title: `Свитшот`,
      description: `Свитшот с оригинальным дизайном понравится и мальчишкам, и девчонкам. Выбирайте яркий принт с любимым киногероем, персонажем мультфильма, шутками и прикольными фразами — насколько хватит фантазии! Наши свитшоты изготовлены из 100% хлопка, не содержат синтетики, поэтому детям в них будет комфортно.`,
      link: `/products/kids_sweatshirts`
    },
    {
      id: `kids-cup`,
      variant: `info`,
      title: `Кружка`,
      description: `Кружка с оригинальным принтом станет отличным подарком ребенку. Уникальный дизайн с любимым персонажем мультика или фильма сделает кружку «своей», и ребенок не захочет с ней расставаться! Как вариант — напечатайте смешную фотку с хулиганской надписью: именинник будет в восторге!`,
      link: `/products/cups`
    },
    {
      id: `notepad`,
      variant: `success`,
      title: `Тетрадь`,
      description: `Идеально в качестве небольшого презента школьнику. Посмотрите, в какие игрушки играет ребенок, и подберите тетрадь с любимым персонажем. Для подростков-старшеклассников сделайте более дерзкие дизайны: с героями сериалов (по химии — Breaking Bad, по литературе — с «Игрой престолов»), фильмов (с Гарри Поттером, Дартом Вейдером) или нейтральные паттерны.`,
      link: `/products/tetradi`
    },
    {
      id: `backpack`,
      variant: `warning`,
      title: `Рюкзак`,
      description: `Подростки способны «убить» рюкзак за один учебный год, поэтому новый придется как нельзя кстати. Главное — узнать у ребенка, что ему нравится больше: Marvel или DC. Самый нейтральный вариант на крайний случай — с Бэтменом: его любят все. А если не нашлось нужного героя, сделайте индивидуальный дизайн с любимым персонажем.`,
      link: `/store/accessories/ryukzaki/printy-po-komiksam`
    },
    {
      id: `kids-tshirt`,
      variant: `danger`,
      title: `Футболка`,
      description: `Простая белая футболка со смешной надписью или любимым героем мультфильма — простой и практичный подарок и для первоклашки, и для подростка. Для детей помладше выбирайте принты с миньонами, свинкой Пеппой, Микки Маусом и Hello Kitty. Детям постарше понравятся футболки с Симпсонами или Футурамой.`,
      link: `/store/kids_items/kids_tees/printy-iz-multikov`
    }
  ]
};
